export default "__VITE_ASSET__W$1QEu_7__"